import { getUserFields } from "components/user/config";
import {
  addItemToCollection,
  getItemsFromCollection,
  updateItemInCollection,
} from "directus/src/operations";

export async function createSelfNomination(data) {
  try {
    const response = await addItemToCollection("performance_review", data);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchReceivedReviews({ quadId, employeeId, revieweeId }) {
  try {
    const query = {
      fields: ["id", "quadrimester", "status", getUserFields("reviewer")],
      filter: {
        quadrimester: { _eq: quadId },
        reviewee: { _eq: employeeId || "$CURRENT_USER" },
        reviewer: { _neq: revieweeId || "$CURRENT_USER" },
      },
    };
    const response = await getItemsFromCollection("performance_review", query);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function fetchSelfEvaluationReview({ quadId }) {
  try {
    const query = {
      fields: ["id", "quadrimester", "status", getUserFields("reviewer"), "*"],
      filter: {
        quadrimester: { _eq: quadId },
        reviewee: { user: { _eq: `$CURRENT_USER` } },
        reviewer: { user: { _eq: `$CURRENT_USER` } },
      },
    };
    const response = await getItemsFromCollection("performance_review", query);
    return response?.[0];
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function createSelfEvaluationReview({
  quadId,
  payload,
  employeeId,
}) {
  try {
    const data = {
      quadrimester: quadId,
      reviewee: employeeId,
      reviewer: employeeId,
      status: "pending", // Or appropriate initial status
      ...payload,
    };
    const response = await addItemToCollection("performance_review", data);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function updatePerformanceReview({ id, payload }) {
  try {
    const response = await updateItemInCollection(
      "performance_review",
      id,
      payload,
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function fetchPendingReceivedReviewsCount({ quadId }) {
  try {
    const query = {
      fields: ["id"],
      filter: {
        quadrimester: { _eq: quadId },
        reviewee: { user: { _eq: "$CURRENT_USER" } },
        reviewer: { user: { _neq: "$CURRENT_USER" } },
        status: { _eq: "pending" },
      },
    };
    const response = await getItemsFromCollection("performance_review", query);
    return response?.length || 0;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchPendingGivenReviewsCount({ quadId }) {
  try {
    const query = {
      fields: ["id"],
      filter: {
        quadrimester: { _eq: quadId },
        reviewer: { user: { _eq: "$CURRENT_USER" } },
        reviewee: { user: { _neq: "$CURRENT_USER" } },
        status: { _eq: "pending" },
      },
    };
    const response = await getItemsFromCollection("performance_review", query);
    return response?.length || 0;
  } catch (error) {
    console.log(error);
    return 0;
  }
}
